import TokenType from "./tokenType.js";
//# sourceMappingURL=parsedTokenInfo.js.map